import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/workspace/layers/admin-panel/layouts/admin.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/workspace/layers/admin-panel/layouts/empty.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/workspace/layers/website/layouts/default.vue").then(m => m.default || m))
}